/**
 * Session countdown formatting helpers
 */

/** Chip turns amber + banner shows below this remaining time. */
export const EXPIRY_WARNING_MS = 15 * 60 * 1000;

/**
 * Format milliseconds remaining as a compact countdown label.
 * "3h 42m left" above an hour, "42m left" below, "<1m left" under a minute.
 */
export function formatTimeRemaining(msRemaining: number): string {
  const totalMinutes = Math.floor(msRemaining / 60000);
  if (totalMinutes < 1) return '<1m left';
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0
    ? `${String(hours)}h ${String(minutes)}m left`
    : `${String(minutes)}m left`;
}
